import { FormControl, Icon } from '@chakra-ui/react';
import { UserSearchIcon } from 'lucide-react';
import { FC } from 'react';
import { useOrganizationCompliancePage } from '~/apps/consumer/pages/Organizations/Compliance/OrganizationCompliancePageContext';
import { SearchInput } from '~/common/components/Inputs/SearchInput';

interface AgentSearchFilterProps {
  placeholder?: string;
}

export const AgentSearchFilter: FC<AgentSearchFilterProps> = ({
  placeholder = 'Search agents',
}) => {
  const { setAgentSearchTerm, agentSearchTerm } =
    useOrganizationCompliancePage();

  return (
    <FormControl>
      <SearchInput
        defaultValue={agentSearchTerm}
        leftIcon={<Icon as={UserSearchIcon} color="purple.500" />}
        placeholder={placeholder}
        w="200px"
        onChange={(e) => setAgentSearchTerm(e.target.value)}
      />
    </FormControl>
  );
};
